import { createAction } from "redux-actions";
import { NEW_NOTIFICATION, UPDATE_NOTIFICATION } from "../constants";
import { feathersCreateData } from "../services";

// cuando se dispara una notificacion
export const newNotification = createAction(NEW_NOTIFICATION, (data) => (data) )
// CUANDO SE CONSULTA LA NOTIFICACION DESDE FEATHERS
export const createNotification = createAction(UPDATE_NOTIFICATION, (data) => feathersCreateData('notifications', data )() )